import { render, staticRenderFns } from "./AffectedShops.vue?vue&type=template&id=7fa9498e"
import script from "./AffectedShops.vue?vue&type=script&lang=js"
export * from "./AffectedShops.vue?vue&type=script&lang=js"
import style0 from "./AffectedShops.vue?vue&type=style&index=0&id=7fa9498e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports